<template>
  <div class='project-spinner-progress'>
    <spinner
      :animation-duration="animationDuration"
      :size="circleSize"
      :color="color"
    />
  </div>
</template>

<script>
import { FulfillingBouncingCircleSpinner } from 'epic-spinners';

export default {
  name: 'ProjectSpinnerProgress',
  props: {
    animationDuration: {
      type: Number,
      default: 3000,
      required: false,
    },
    circleSize: {
      type: Number,
      default: 20,
      required: false,
    },
    color: {
      type: String,
      default: '#2459D5',
      required: false,
    },
  },
  components: {
    Spinner: FulfillingBouncingCircleSpinner,
  },
};
</script>

<style lang='scss' scoped>
.project-spinner-progress {
  position: relative;
}
</style>
